import React, { createContext, useContext, useEffect, useState } from "react";
import { AxiosContext } from "./AxiosContext";
import { toast } from "react-toastify";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingNotificationTasks, setIsLoadingNotificationTasks] =
    useState(false);

  const [formData, setFormData] = useState({
    title: "",
    body: "",
    target: [],
  });
  const [tasks, setTasks] = useState([]);
  const { axiosInstance } = useContext(AxiosContext);

  const fetchNotificationTasks = async () => {
    try {
      setIsLoadingNotificationTasks(true);
      const { data } = await axiosInstance.get("/notifications/task");
      setTasks(data.data);
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to fetch notification tasks"
      );
    } finally {
      setIsLoadingNotificationTasks(false);
    }
  };

  const submitNotificationTask = async (task) => {
    try {
      console.log("submitNotificationTask", task)
      const { data } = await axiosInstance.post("/notifications/task", task);
      setTasks((prev) => [data.data, ...prev]);
      fetchNotificationTasks()
      toast.success("Notification task successfully created");
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to create notification task"
      );
    }
  };

  useEffect(() => {
    if (!axiosInstance) return;
    fetchNotificationTasks();

    return () => {};
  }, [axiosInstance]);

  const toastSuccess = (message) => toast.success(message);
  const toastError = (message) => toast.error(message);

  return (
    <NotificationContext.Provider
      value={{
        tasks,
        fetchNotificationTasks,
        submitNotificationTask,
        open,
        setOpen,
        isLoading,
        setIsLoading,
        formData,
        setFormData,
        isLoadingNotificationTasks,
        toastSuccess,
        toastError,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
